import styled from '@emotion/styled';
import Link from 'next/link';

import { PStyles } from '../type';
import { BREAKPOINTS, COLORS, SPACE } from '../../constants';

const CardWrapper = styled(Link)`
  && {
    background-color: ${COLORS.WHITE};
    border-radius: 0;
    box-shadow: 0 1px 5px 1px ${COLORS.GREY_FOUR};
    display: flex;
    flex-direction: column;
    padding: ${SPACE.X2};
    text-align: center;
    width: 100%;

    @media (min-width: ${BREAKPOINTS.MD}px) {
      padding: ${SPACE.X1};
    }
  }
`;

const CarImageWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 170px;
  ${
    /* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'flexStart' does not exist on type '{ theme?: Theme | undefined; as?: ElementType<any, keyof IntrinsicElements> | undefined; } & ClassAttributes<HTMLDivElement> & HTMLAttributes<...> & { ...; }'. */
    ({ flexStart }) => flexStart && 'justify-content: flex-start;'
  };
`;

const CarImage = styled.img`
  max-height: 170px;
  max-width: 100%;
`;

const ModelDetails = styled.div`
  padding-bottom: ${SPACE.X2};
  padding-top: ${SPACE.X0};

  @media (min-width: ${BREAKPOINTS.MD}px) {
    padding-bottom: ${SPACE.X1};
  }
`;

const ModelYear = styled.span`
  ${PStyles};
`;

const Rating = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: ${SPACE.X1};

  @media (min-width: ${BREAKPOINTS.MD}px) {
    padding-bottom: ${SPACE.X0};
  }
`;

const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-end;
  margin-top: auto;
  width: 100%;
`;

const TestDetails = styled.div`
  padding-bottom: ${SPACE.X2};
  padding-top: ${SPACE.X0};

  @media (min-width: ${BREAKPOINTS.MD}px) {
    padding-bottom: ${SPACE.X1};
  }
`;

const PriceRangeDetails = styled.div`
  border-top: 1px solid ${COLORS.GREY_FOUR};
  padding-bottom: ${SPACE.X1};
  padding-top: ${SPACE.X1};

  @media (min-width: ${BREAKPOINTS.MD}px) {
    padding-bottom: ${SPACE.X0};
    padding-top: ${SPACE.X0};
  }
`;

export {
  BottomContainer,
  CardWrapper,
  CarImage,
  CarImageWrapper,
  ModelDetails,
  ModelYear,
  PriceRangeDetails,
  Rating,
  TestDetails,
};
